import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import {Translate} from "../../../config/Translate";
import { Offline } from "react-detect-offline";
import IconButton from "@material-ui/core/IconButton/IconButton";
import WifiOffIcon from '@material-ui/icons/WifiOff';
export default function CheckInternetConnection() {
    return (
        <Offline>
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                open={true}
                message={Translate.connectionError}
                action={
                    <React.Fragment>
                        <IconButton size="small">
                            <WifiOffIcon color="secondary" fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                }
            />
        </Offline>
    );
}
